import React, { Component } from 'react';
import { Route, Redirect } from 'react-router';
import { AppBody } from './components/AppBody';
import { Home } from './components/Home';
import { FetchData } from './components/FetchData';
import { Counter } from './components/Counter';
//import Route from './components/api-authorization/Route';
//import ApiAuthorizationRoutes from './components/api-authorization/ApiAuthorizationRoutes';
import AuthorizeRoute from './components/api-authorization/AuthorizeRoute';
import { Login } from './components/auth/Login';
import Session from './components/auth/Session';
import { ApplicationPaths } from './components/api-authorization/ApiAuthorizationConstants';
import { Roles } from './components/admin/Roles';
import { CreateRole } from './components/admin/CreateRole';
import { AccessDenied } from './components/util/AccessDenied';
import './custom.css'
import { Users } from './components/admin/Users';
import { Clients } from './components/admin/Clients';
import { RoleDetails } from './components/admin/RoleDetails';
import { UserDetails } from './components/admin/UserDetails';
import { CreateClient } from './components/admin/CreateClient';
import { ClientDetails } from './components/admin/ClientDetails';
import { LeaseSearch } from './components/Lease/LeaseSearch';
import { LeaseDetailsSummary } from './components/Lease/LeaseDetails-Summary';
import { LeaseDetailsRentTerms } from './components/Lease/LeaseDetails-RentTerms';
import { LeaseDetailsCriticalDates } from './components/Lease/LeaseDetails-CriticalDates';
import { LeaseDetailsNotes } from './components/Lease/LeaseDetails-Notes';
import { LeaseDetailsDocuments } from './components/Lease/LeaseDetails-Documents';
import { LeaseDetailsContacts } from './components/Lease/LeaseDetails-Contacts';
import { CriticalDatesList } from './components/Lease/CriticalDates-List';
import { AddLease } from './components/Lease/AddLease';
import { ActiveLeases } from './components/Lease/ActiveLeases';
import { LeaseDashboard } from './components/Lease/LeaseDashboard';
import { Admin } from './components/admin/Admin';
//import { Login } from './components/Login';
import { ForgotPassword } from './components/ForgotPassword';
import { ResetPassword } from './components/ResetPassword';
import { AcctDetails } from './components/User/AcctDetails';
import AdminFunctions from './components/admin/AdminFunctions';
import AuthFunctions from './components/services/AuthService';
import { CompSearch } from './components/Comps/CompSearch';
import { CompsList } from './components/Comps/CompsList';
import { CompsAdd } from './components/Comps/CompAdd';
import { CompsIndex } from './components/Comps/Index';
import { CompSummary } from './components/Comps/CompSummary';

export default class App extends Component {
    static displayName = App.name;
    constructor(props) {
        super(props);
        
        this.state = {
            authenticated: false,
            admin: false,
            loading: true
        }
        

    }

    async componentDidMount() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        var isRead = false;
        var isHomeL = false;
        var isComps = false;
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            if (!isAdmin) {
                isWrite = await AdminFunctions.isRole("Write");
                isRead = await AdminFunctions.isRole("ClientRead");
                isHomeL = await AdminFunctions.isRole("Home Limited");
                isComps = await AdminFunctions.isRole("Comps");
            } else {
                isWrite = true;
                isHomeL = true;
            }
        }
        var isValidForLease = isWrite || isHomeL || isAdmin || isRead;
        this.setState({ authenticated: isAuthenticated, admin: isAdmin, loading: false, write: isWrite, homeL: isHomeL, isComps: isComps, isValidForLease: isValidForLease });
    }

    render() {
        return (
            <AppBody>
                <Route path='/home' component={LeaseSearch} />
                {/*<Route path='/login' component={Login} />*/}
                <Route path='/forgotpassword' component={ForgotPassword} />
                <Route path='/resetpassword' component={ResetPassword} />
                <Route path='/counter' component={Counter} />
                <Route path='/fetch-data' component={FetchData} />
                <Route exact path='/admin' component={Admin} />
                <Route exact path='/admin/roles' component={Roles} />
                <Route exact path='/admin/roles/create' component={CreateRole} />
                <Route exact path='/admin/roles/details' component={RoleDetails} />
                <Route exact path='/admin/users' component={Users} />
                <Route exact path='/User/AcctDetails' component={AcctDetails} />
                <Route exact path='/admin/users/details' component={UserDetails} />
                <Route exact path='/admin/clients' render={() => {
                    if (this.state.loading === false) {
                        if (this.state.authenticated === true) {
                            if (this.state.homeL === true || this.state.isComps === true) {
                                return <Clients/>
                            }
                            else {
                                return <Redirect to="/Lease/LeaseSearch" />
                            }
                        } else {
                            return <Redirect to="/login" />
                        }
                    } else {
                        return <Redirect to="/" />
                    }
                }} />
                <Route exact path='/admin/clients/create' component={CreateClient} />
                <Route exact path='/admin/clients/details' component={ClientDetails} />
                <Route path='/Lease' render={() => {
                    // Guard once for all /Lease/* routes. Mirrors the branch's
                    // three-level check: loading -> authenticated -> isValidForLease.
                    // The loading short-circuit prevents a false redirect to
                    // /AccessDenied before the async role check finishes.
                    if (this.state.loading === false) {
                        if (this.state.authenticated === true) {
                            if (this.state.isValidForLease) {
                                return (
                                    <>
                                        <Route exact path='/Lease/LeaseSearch' component={LeaseSearch} />
                                        <Route exact path='/Lease/AddLease' component={AddLease} />
                                        <Route exact path='/Lease/LeaseDetails-Summary' component={LeaseDetailsSummary} />
                                        <Route exact path='/Lease/LeaseDetails-RentTerms' component={LeaseDetailsRentTerms} />
                                        <Route exact path='/Lease/LeaseDetails-CriticalDates' component={LeaseDetailsCriticalDates} />
                                        <Route exact path='/Lease/LeaseDetails-Notes' component={LeaseDetailsNotes} />
                                        <Route exact path='/Lease/LeaseDetails-Documents' component={LeaseDetailsDocuments} />
                                        <Route exact path='/Lease/LeaseDetails-Contacts' component={LeaseDetailsContacts} />
                                        <Route exact path='/Lease/CriticalDates-List' component={CriticalDatesList} />
                                        <Route exact path='/Lease/ActiveLeases' component={ActiveLeases} />
                                        <Route exact path='/Lease/LeaseDashboard' component={LeaseDashboard} />
                                    </>
                                );
                            }
                            else {
                                return <Redirect to="/AccessDenied" />
                            }
                        } else {
                            return <Redirect to="/login" />
                        }
                    } else {
                        return <></>
                    }
                }} />

                {/*<Route path={ApplicationPaths.ApiAuthorizationPrefix} component={ApiAuthorizationRoutes} />*/}
                <Route exact path='/login' component={Login} />
                <Route exact path='/logout' render={() => {
                    Session.removeUserSession();
                    window.location.href = '/login';
                    return <></>;
                }} />
                <Route exact path='/forgot' render={() => {
                    window.location.href = '/Identity/Account/ForgotPassword';
                    return <></>;
                }} />
                <Route exact path='/accessdenied' component={AccessDenied} />
                <Route exact path="/" render={() => {
                    if (this.state.loading === false) {
                        if (this.state.authenticated === true) {
                            if (this.state.homeL === true || this.state.isComps === true) {
                                return <Redirect to="/admin/Clients" />
                            }
                            else {
                                return <Redirect to="/Lease/LeaseSearch" />
                            }
                        } else {
                            return <Redirect to="/login" />
                        }
                    } else {
                        return <Redirect to="/"/>
                    } 
                }} />
                <Route exact path='/Comps/CompSearch' component={CompSearch} />
                <Route exact path='/Comps/CompsList' component={CompsList} />
                <Route exact path='/Comps/Index' component={CompsIndex} />
                <Route exact path='/Comps/CompsAdd' component={CompsAdd} />
                <Route exact path='/Comps/CompSummary' component={CompSummary} />
            </AppBody>
        );
    }
}
